(() => {
  const codeMessageElem = document.querySelector(".js-code-message");
  const codeElem = document.querySelector(".js-code");
  const announcementBar = document.querySelector(".js-announcement-bar");

  const formatTimeRemaining = (isoString, translations) => {
    const targetDate = new Date(isoString);
    const now = new Date();
    const timeDifference = targetDate - now;

    if (timeDifference <= 0) {
      return translations?.passedTranslation || "The date has already passed.";
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    let message;

    if (days > 0) {
      message =
        translations?.daysHoursTranslation ||
        "Only <<days>> days and <<hours>> hours left.";
    } else if (hours > 0) {
      message =
        translations?.hoursMinutesTranslation ||
        "Only <<hours>> hours and <<minutes>> minutes left.";
    } else if (minutes > 0) {
      message =
        translations?.minutesSecondsTranslation ||
        "Only <<minutes>> minutes and <<seconds>> seconds left.";
    } else {
      message =
        translations?.secondsTranslation || "Only <<seconds>> seconds left.";
    }

    return message
      .replace("<<days>>", days)
      .replace("<<hours>>", hours)
      .replace("<<minutes>>", minutes)
      .replace("<<seconds>>", seconds);
  };

  const initAnnouncementBar = () => {
    if (!announcementBar) return;

    const messages = document.querySelectorAll(".js-announcement-bar-message");
    let currentIndex = 0;
    const interval = parseInt(announcementBar.dataset.interval, 10) || 5000;

    const showNextMessage = () => {
      const currentMessage = messages[currentIndex];
      currentMessage.classList.remove(
        "offer-announcement-bar__message--visible"
      );
      currentMessage.classList.add("offer-announcement-bar__message--fade-out");

      setTimeout(() => {
        currentMessage.classList.remove(
          "offer-announcement-bar__message--fade-out"
        );
        currentIndex = (currentIndex + 1) % messages.length;
        const nextMessage = messages[currentIndex];
        nextMessage.classList.add("offer-announcement-bar__message--visible");
      }, 1000);
    };

    messages[currentIndex].classList.add(
      "offer-announcement-bar__message--visible"
    );

    setInterval(showNextMessage, interval);
  };

  const initTimeRemaining = () => {
    const timeRemainingElement = document.querySelector(".js-time-remaining");
    if (!timeRemainingElement) return;

    const { endDate } = timeRemainingElement.dataset;
    const translations = announcementBar.dataset;

    const updateCountdown = () => {
      const timeRemainingText = formatTimeRemaining(endDate, translations);
      timeRemainingElement.textContent = timeRemainingText;
    };

    // Function to determine the appropriate interval
    const getInterval = () => {
      const timeDifference = new Date(endDate) - new Date();
      if (timeDifference <= 0) return 0;
      return timeDifference <= 1000 * 60 * 60 ? 1000 : 1000 * 60; // Every second if <1hr, otherwise every minute
    };

    // Recursive function to update at different intervals
    const scheduleUpdate = () => {
      const interval = getInterval();
      if (interval === 0) {
        // If time has passed, stop updates and set final message
        timeRemainingElement.textContent =
          translations.passedTranslation || "The date has already passed.";
        return;
      }

      // Update countdown and set next interval
      updateCountdown();
      setTimeout(scheduleUpdate, interval);
    };

    // Start the recursive updates
    scheduleUpdate();
  };

  const handleCopy = async () => {
    const originalText = codeElem.textContent.trim();

    try {
      // Use the Clipboard API to copy the text content
      await navigator.clipboard.writeText(originalText);
      const copyTranslation = codeElem.dataset.copyTranslation || "Copied!";

      codeElem.textContent = copyTranslation;

      setTimeout(() => {
        codeElem.textContent = originalText;
      }, 3000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  if (window.innerWidth < 1024) {
    initAnnouncementBar();
  }

  initTimeRemaining();

  if (codeMessageElem) {
    codeMessageElem.addEventListener("click", handleCopy);
  }
})();
